import { BigChevronLeftIcon, Typography } from '@forgeglobal/design-framework';
import AccountTransactionsTable from '@tcs/client-portal-common/components/molecules/AccountTransactionsTable';
import { useStyles } from './style';
import AssetInfoCard from '@tcs/client-portal-common/components/molecules/AssetInfoCard';
import { AssetModel } from '@tcs/client-portal-api/platform_generated';
import { Investment } from '@tcs/client-portal-api/types/Investment';
import { Transaction } from '@tcs/client-portal-api/types/Transaction';
import formatCurrency from '@tcs/common/utils/formatCurrency';

interface TransactionsTableProps {
  accountNumber: string;
  accountHolding: Investment;
  transactions: Transaction[];
  showBalance: boolean;
  showUnits: boolean;
  minimumCashBalance?: number;
  loading: boolean;
  interestRate?: number;
  effectiveDate?: string;
  onBackButtonClick: () => void;
}

const TransactionsTable = ({
  accountNumber,
  accountHolding,
  transactions,
  showBalance,
  showUnits,
  minimumCashBalance,
  loading,
  onBackButtonClick,
  interestRate,
  effectiveDate,
}: TransactionsTableProps) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>
        <BigChevronLeftIcon
          onClick={onBackButtonClick}
          className={classes.icon}
        />
        <Typography variant="h5" color="textPrimary">
          {accountHolding.assetDescription} - Transactions
        </Typography>
      </div>
      {accountHolding.assetValueType === AssetModel.AssetValueType.NOTE && (
        <div className={classes.assetInfoCard}>
          <AssetInfoCard
            title="Asset Information"
            accountNumber={accountNumber}
            assetCode={accountHolding.assetCode}
          />
        </div>
      )}
      {minimumCashBalance !== undefined && (
        <div className={classes.minimumCashBalance}>
          Required Minimum Cash Balance: {formatCurrency(minimumCashBalance)}
        </div>
      )}
      {effectiveDate !== undefined && (
        <div className={classes.interestRate}>
          {interestRate}% APY Effective {effectiveDate}
        </div>
      )}
      <AccountTransactionsTable
        transactions={transactions}
        showBalance={showBalance}
        showUnits={showUnits}
        loading={loading}
      />
    </div>
  );
};

export default TransactionsTable;
